import { useState, useEffect} from 'react';
import Barchart from '../Barchart';
import Doughnutchart from '../Doughnutchart';
import CustomTable from "../CustomTable"
import LineChart from './LineChart';


function DayAirportResult({TimeOption, RegionIndicator, Time, MeasurementIndicator, AirportCodes, chartType}) {

    const [userData, setUserData] = useState([]);

    const [excelDataChart,setexcelDataChart] = useState([]);

    console.log("Time",Time)
    const [day, month, year] = Time.split("/");
    console.log("Day:", day); // Output: Day: 4
    console.log("Month:", month); // Output: Month: 12
    console.log("Year:", year); // Output: Year: 2017
    
    

    useEffect(() => {
        fetch("api/get_indicator_by_day/", {method: "post", headers: {'Content-Type':'application/json'}, body:JSON.stringify({ ind_name: MeasurementIndicator, year: parseInt(year), month: parseInt(month), day: parseInt(day) })}).then((res) =>
           res.json().then((res) => {

            
            console.log("Result",res)
           
 
            const keys = Object.keys(res.data.data);
            
            
            let listOfIds = []
            let listOfValues = []

            keys.forEach((airport, i) => {
                //Slice airport to get the same code ex instead of Airport Κρατικός Αερολιμένας Καρπάθου (AOK) get AOK to match the code passed
                const str = JSON.stringify(airport);
                const code2 = str.slice(-5,-2)


                // TODO: CHECK IF CODES ARE GOOD MIGHT BE A DIFFERENT SLICE
                

                //Check if code mataches our Airport Code
                if(AirportCodes.includes(code2)) {
                    listOfValues.push(res.data.data[airport])
                    listOfIds.push(code2)
                }


                
            });



            if(listOfIds.length !== 0 && listOfValues.length !== 0){
                setUserData({
                    labels: listOfIds,
                    datasets: [{
                    label: "",
                    data: listOfValues,
                    backgroundColor: "#0F8DD6",
                    borderColor: "black",
                    borderWidth: 0.1,
                    }]
                })

                let exceldata = []
                for (let i = 0; i < listOfIds.length; i++) {
                    exceldata.push({"Αεροδρόμιο": listOfIds[i], "Τιμή": listOfValues[i]})
                }
            

                setexcelDataChart(exceldata)

            }
            else {
                setUserData({
                    labels: listOfIds,
                    datasets: [{
                    label: "",
                    data: listOfValues,
                    backgroundColor: "#0F8DD6",
                    borderColor: "black",
                    borderWidth: 0.1,
                    }]
                })

                let exceldata = []
                exceldata.push({"Αεροδρόμιο": "", "Τιμή": ""})
                setexcelDataChart(exceldata)
            }
            
   

              

           
          })
        )
        .catch((error) => {
          console.log("Refetching data for airport info!")
        });
      }, [MeasurementIndicator,AirportCodes, day, month,year]);
    



    let component;

    
    if(userData.length !== 0){
        switch (chartType) {
            case 0:
                let BarChartoptions = {
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        legend: {
                        position: 'bottom',
                        },
                    },
                    scales: {
                        y: {
                        suggestedMin: 0,
                        },
                    }
                }
                
                component = <Barchart chartData={userData} chartOptions = {BarChartoptions} excelData ={excelDataChart}> </Barchart>
           
            break;
            case 1:

                let Doughnutchartoptions = {maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                    legend: {
                        position: 'right',
                    },
                    }
                }
                component = <Doughnutchart chartData={userData} chartOptions ={Doughnutchartoptions} excelData = {excelDataChart} ></Doughnutchart>
           
            
            break;
            case 2:
                if(excelDataChart.length !== 0) {
                    component = <CustomTable data = {excelDataChart}></CustomTable>
                }else {
                    component = <></>
                }                   
            
            break;
        
            case 3:

            let LineChartoptions = {
                maintainAspectRatio: false,
                responsive: true,
                plugins: {
                  legend : {
                   display: false,
                  }
                }
              }
            
              component = <LineChart chartData={userData} chartOptions = {LineChartoptions} excelData ={excelDataChart}></LineChart>
            
            break;
            default:
            component = <h1>Παρακαλώ επιλέξτε τύπο διαγράμματος</h1>;
        }
       
        
        return (
            <div className="container filters-wrapper" style = {{marginTop: "5%"}}>
                <div style = {{display: "flex", marginTop: "3%"}}>
                    <div>
                        <p>Επιλεγμένη χρονική περίοδος</p>
                        <p><strong>{TimeOption}</strong></p>
                    </div>
                    <div style = {{marginLeft: "25%"}}>
                        <p>Επιλεγμένος δείκτης μέτρησης</p>
                        <p><strong>{RegionIndicator}</strong></p>
                    </div>
                </div>
                <div style = {{display: "flex"}}>
                    <div>
                        <p>Επιλεγμένη περίοδος</p>
                        <p><strong>{Time}</strong></p>
                    </div>
                    <div style = {{marginLeft: "32%"}}>
                        <p>Επιλεγμένοι δείκτες</p>
                        <p><strong>{MeasurementIndicator}</strong></p>
                    </div>

                </div>

                
                {component}
            
            </div>
        );
    }
    else {
        return (<></>)
    }
}

export default DayAirportResult;
